export default "__VITE_ASSET__BSW1Qmct__"